// 个人屏蔽只接入约定的列表与管理接口，避免改变收藏、热帖和原黑名单行为。
const PERSONAL_POST_PATHS = [
  '/elk/queryPost/scroll',
  '/elk/query_string',
  '/elk/post',
  '/yca/post/page',
];

export const POST_BLOCK_CHANGE_EVENT = 'yca-post-block-change';
export const POST_SESSION_CHANGE_EVENT = 'yca-post-session-change';

export function isPostBlockManagement(url = '') {
  return /\/yca\/post-blocks(?:\/[^/?]+)?\/?(?:\?|$)/.test(url);
}

export function isPersonalPostRequest(url = '') {
  const pathname = url.split('?')[0].replace(/\/$/, '');
  return isPostBlockManagement(url) || PERSONAL_POST_PATHS.some(path => pathname.endsWith(path));
}

// 会话键仅用于本地判断请求归属，不写入日志、地址或个人屏蔽接口参数。
export function getPostSessionIdentity() {
  return JSON.stringify([
    window.localStorage.getItem('openId'),
    window.localStorage.getItem('sessionKey'),
  ]);
}

export function notifyPostBlocksChanged() {
  window.dispatchEvent(new Event(POST_BLOCK_CHANGE_EVENT));
}

// 只接受规范 postId，不把 ES 文档 ID 或原系统记录 ID 当作帖子 ID。
export function getBlockPostId(item) {
  const value = item && item.postId;
  return /^\d+$/.test(String(value)) && Number.isSafeInteger(Number(value)) && Number(value) > 0
    ? value
    : null;
}
